/**
 * ClearButton — T24.
 *
 * Shows a confirm dialog ("Clear output and brief?") before clearing.
 * On confirm: resets the brief form and run-stream store.
 * On cancel: does nothing.
 */
import { Button } from '@mantine/core';
import { useBriefFormStore } from '../../state/brief-form-store';
import { useRunStreamStore } from '../../state/run-stream-store';

interface ClearButtonProps {
  disabled?: boolean;
}

export function ClearButton({ disabled = false }: ClearButtonProps) {
  const briefForm = useBriefFormStore();
  const runStream = useRunStreamStore();

  function handleClick() {
    const confirmed = window.confirm('Clear output and brief?');
    if (!confirmed) return;

    briefForm.reset();
    runStream.reset();
  }

  return (
    <Button
      variant="default"
      size="xs"
      onClick={handleClick}
      disabled={disabled}
      data-testid="clear-btn"
    >
      Clear
    </Button>
  );
}
